import React from "react";
import "./PerfumeManufacture.css";
import HaveAScent from "../../Components/HaveAScent";

const PerfumeManufacture = () => {
  return (
    <div>
      <p className="mt-[50px] mb-[50px] text-black text-5xl text-center">
        PERFUMES
      </p>
      <img
        className="w-[100vw] min-h-[30vh] bg-cover bg-center flex justify-center items-center"
        src="https://tomanddarin.com/cdn/shop/files/perfume_for_all_29fc2ed3-6348-4f20-a898-d5d9000116b5.jpg?v=1725519839&width=2000"
        alt=""
      />

      <div className="w-[90%] sm:w-[70%] mx-auto my-10 flex flex-col sm:flex-row items-center gap-10">
        <div className="sm:w-[50%]">
          <p className="text-4xl my-6 font-bold">
            The Perfume Manufacturing Process
          </p>
          <p className="text-2xl my-3">
            Making a perfume involves collecting ingredients, extracting oils,
            blending, aging and quality control.
          </p>
          <p className="text-2xl my-3">
            Blending aromatic compounds, solvents, and fixatives to create
            unique and long-lasting scents.
          </p>
          
        </div>
        <img
          className="sm:w-[50%]"
          src="https://tomanddarin.com/cdn/shop/files/Amazinglove3_1066x.png?v=1726215280"
          alt=""
        />
      </div>

      <div className="w-[90%] sm:w-[70%] mx-auto my-10 flex flex-col sm:flex-row items-center gap-10">
        <img
          className="sm:w-[50%]"
          src="https://i.ibb.co.com/SwQGHv8V/next-care.avif"
          alt=""
        />
        <div className="sm:w-[50%]">
          {/* <p className="text-4xl my-6 font-bold">
            The Perfume Manufacturing Process
          </p> */}
          <p className="text-2xl my-3">
            The creation of Smart Collection No. 387 is an exacting journey of
            olfactory craftsmanship. It begins with the precise procurement of
            high-quality raw ingredients, followed by the careful extraction of
            pure aromatic oils.
          </p>
          <p className="text-2xl my-3">
            Through a rigorous cycle of aging and stringent quality control, we
            ensure that every bottle reflects our commitment to excellence.
          </p>
          <a
              href="https://luvit.com.bd/brand/smart-collection"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-black hover:bg-[#254f07] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105">
                See  full range  →
              </button>
            </a>
        </div>
      </div>
      
      <div className="w-[90%] sm:w-[70%] mx-auto my-10 flex flex-col sm:flex-row items-center gap-10">
        <div className="sm:w-[50%]">
          {/* <p className="text-4xl my-6 font-bold">
            The Perfume Manufacturing Process
          </p> */}
          <p className="text-2xl my-3">
            Experience an aura of sophistication with Smart Collection HOGO BOSS, a fragrance designed for the modern man who values confidence and refinement.
          </p>
          <p className="text-2xl my-3">
            this perfume captures a premium, cinematic allure, making it a standout addition to any collection.
          </p>
          <a
              href="https://luvit.com.bd/brand/smart-collection"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-black hover:bg-[#254f07] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105">
                See  full range  →
              </button>
            </a>
        </div>
        <img
          className="sm:w-[50%]"
          src="https://i.ibb.co.com/fdzjg60X/nextcare-smartcollection-avif-2.avif"
          alt=""
        />
      </div>

      <div className="w-[90%] sm:w-[70%] mx-auto my-10 flex flex-col sm:flex-row-reverse items-center gap-10">
        <div className="sm:w-[50%]">
          <p className="mb-6 text-xl">
            We handpick various notes and precisely blend them with exact
            percentages to curate the perfect fragrance that soothes your
            senses.
          </p>
          <p className="mb-6 text-xl">
            Our team of expert perfumers carefully selects each note—from fresh
            top notes to warm base notes—to ensure a harmonious balance in every
            bottle. We believe in delivering a scent that not only lasts but
            also evokes emotions and unforgettable experiences.
          </p>
          <p className="mb-6">
            Whether it’s the floral hints that relax your mind or the woody
            undertones that add depth, each fragrance is designed to complement
            your unique personality.
          </p>
          {/* <p className="mb-6">
            Blending science with art, we meticulously calculate the ratios of essential oils and aromatic compounds to craft fragrances that resonate with timeless elegance and modern style.
          </p> */}
          <p className="mb-6">
            Our commitment to quality ensures that each bottle reflects the
            dedication, precision, and creativity that goes into every fragrance
            we produce.
          </p>
        </div>
        <img
          className="sm:w-[50%]"
          src="https://tomanddarin.com/cdn/shop/files/j3_720x.webp?v=1713349444"
          alt=""
        />
      </div>

      <HaveAScent color="#FF8672" />
    </div>
  );
};

export default PerfumeManufacture;
